import React, { createContext, useState } from "react";
export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [registerData, setRegisterData] = useState([])
  const [actionType, setActionType] = useState([])
  const [project, setProject] = useState({})

  // Example login and logout functions
  const login = (userData) => {
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData)); // Persist user data
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user"); // Clear user data
  };

  const setProjectDet = (projectDet) => {
    setProject(projectDet)
    localStorage.setItem("projectDet", JSON.stringify(projectDet))
  }

  
  const setType = (type) => {
    setActionType(type)
    localStorage.setItem("type", type)
  }
  const getType = () => {
    return localStorage.getItem("type")
  }
  const setRegisterMapData = (name, registerData) => {
    setRegisterData(registerData)
    localStorage.setItem(name, JSON.stringify(registerData))
  }

  const getRegisterMapData = (name, registerData) => {
    return JSON.parse(localStorage.getItem(name))
  }
  const clearRegisterMapData = (name) => {
    setRegisterData(null)
    localStorage.removeItem(name)
  }

  return (
    <AuthContext.Provider value={{
      user, login, logout,
      registerData, setRegisterMapData, clearRegisterMapData, getRegisterMapData,
      actionType, setType, getType
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
